import React from 'react';
import SelectInput from './SelectInput';
import { Project, CostCenterItem } from './Types'


const valueGetter = (project: Project) => project.project_id
const nameGetter = (project: Project) => project.ProjectName
const emptyArray: Project[] = []


function ProjectSelect({costCenterItem, value, onChange, required, ...props}: {
  costCenterItem: CostCenterItem | null,
  value: string | null,
  onChange: (newProjectId: string) => void,
  required: boolean,
  label?: string,
  disabled?: boolean,
  sx?: {}
}) {
  return (
    <SelectInput
      options={costCenterItem !== null ? costCenterItem.projects : emptyArray}
      valueGetter={valueGetter}
      nameGetter={nameGetter}
      value={value}
      onChange={onChange}
      required={required}
      {...props}
    />
   )

}


export function asValidProjectId({projects, project_id}: {projects: Project[], project_id: string | null}): string | null {
  return isValidProject({projects, project_id}) ? project_id : null
}

export function isValidProject({projects, project_id}: {projects: Project[], project_id: string | null}): boolean {
  return projects.find(project => project.project_id === project_id) !== undefined
}

// function ProjectSelectRaw({projects, onChange, value, ...props}) {
//   const isValid = isValidProject({projects: projects, project_id: value})
//   const theValue = isValid ? value : ''
//   return (
//     <Select {...props} value={theValue} autoWidth={true} onChange={(e) => {onChange(e.target.value)}}>
//       <MenuItem value=""></MenuItem>
//       {projects.map(project => <MenuItem key={project.project_id} value={project.project_id}>{project.ProjectName}</MenuItem>)}
//     </Select>
//   )
// }

// function ProjectSelect({costCenterItem, ...props}) {
//   const localIsValidProject = (project_id => isValidProject({projects: costCenterItem.projects, project_id: project_id}))
//   return FormWrapper({Component: ProjectSelectRaw, validationFunction: localIsValidProject})({projects: costCenterItem.projects, ...props})
// }

export default ProjectSelect
